var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "show",
          rawName: "v-show",
          value: _vm.uploadCsvShow,
          expression: "uploadCsvShow"
        }
      ],
      staticClass: "popup"
    },
    [
      _c("div", { staticClass: "content", attrs: { id: "uploadCsv" } }, [
        _c("div", { staticClass: "title" }, [
          _vm._v(
            "\n             " +
              _vm._s(_vm.$t("language.paySystem.Notice")) +
              "\n              "
          ),
          _c("div", {
            staticClass: "icon white-close dialog-close",
            on: {
              click: function($event) {
                return _vm.closePage()
              }
            }
          })
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "delete-remind-content" }, [
          _c(
            "div",
            {
              staticStyle: {
                float: "left",
                width: "100%",
                height: "80px",
                color: "#494949",
                "line-height": "20Px"
              }
            },
            [
              _vm._v(" " + _vm._s(_vm.noticeTxt) + " "),
              _c(
                "span",
                {
                  staticClass: "downLoad-link",
                  on: {
                    click: function($event) {
                      return _vm.downloadcSV()
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("language.teamTransfer.csvFormat")))]
              )
            ]
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "team-footer", staticStyle: { float: "left" } },
            [
              _c("div", { staticClass: "uploadCsv-botton" }, [
                _c("div", { staticClass: "uploadCsv-txt" }, [
                  _c("div", {
                    staticClass: "icon-util tab-float",
                    class: _vm.check ? "check-small" : "nocheck-small-blue",
                    on: {
                      click: function($event) {
                        $event.stopPropagation()
                        return _vm.dontShow()
                      }
                    }
                  }),
                  _vm._v(
                    "\n                      " +
                      _vm._s(_vm.$t("language.teamTransfer.dontShow")) +
                      "\n                  "
                  )
                ]),
                _vm._v(" "),
                _c(
                  "button",
                  {
                    staticClass: "uploadCsv-botton-right",
                    on: {
                      click: function($event) {
                        return _vm.ok()
                      }
                    }
                  },
                  [_vm._v(_vm._s(_vm.$t("language.common.ok")))]
                )
              ])
            ]
          )
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-188a199b", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-188a199b","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/popup/team_transfer_popups/upload_csv_popups.vue
// module id = null
// module chunks = 